var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"validacion",class:[_vm.isForResponsive],attrs:{"id":"fbButton"},on:{"click":_vm.doLogin}},[_c('span',[_vm._v("LOGIN CON FACEBOOK")]),_c('img',{staticStyle:{"width":"15px","margin-left":"10px"},attrs:{"src":_vm.facebook}})])
}
var staticRenderFns = []

export { render, staticRenderFns }